/*
*
* File JS per il TPL Contatti
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import maps from 'components/maps/maps';

import contactForm from 'components/contact-form/contact-form';

import modal from 'components/modal/modal';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './contact-page.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

maps();

contactForm();

modal();

//--------------------------------------------------------------------//